import { render } from "./ClassificationAccuracyReport.vue?vue&type=template&id=db6be4fa&scoped=true"
import script from "./ClassificationAccuracyReport.vue?vue&type=script&lang=js"
export * from "./ClassificationAccuracyReport.vue?vue&type=script&lang=js"

import "./ClassificationAccuracyReport.vue?vue&type=style&index=0&id=db6be4fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db6be4fa"]])

export default __exports__